'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_LineageGraphEntry(data, parents) {
  this.Fw = null;
  this.Y6 = null;
  this.Fw = data;
  this.Y6 = parents;
}
export { $c_Lapp_data_LineageGraphEntry as $c_Lapp_data_LineageGraphEntry };
$p = $c_Lapp_data_LineageGraphEntry.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_LineageGraphEntry;
/** @constructor */
function $h_Lapp_data_LineageGraphEntry() {
}
export { $h_Lapp_data_LineageGraphEntry as $h_Lapp_data_LineageGraphEntry };
$h_Lapp_data_LineageGraphEntry.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_LineageGraphEntry)) {
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().C(this.Fw, x$0.Fw)) {
      var x$1 = this.Y6;
      var x$2 = x$0.Y6;
      return ((x$1 === null) ? (x$2 === null) : x$1.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "LineageGraphEntry";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Fw;
  }
  if ((n === 1)) {
    return this.Y6;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "data";
  }
  if ((n === 1)) {
    return "parents";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_LineageGraphEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jH)));
}
export { $isArrayOf_Lapp_data_LineageGraphEntry as $isArrayOf_Lapp_data_LineageGraphEntry };
var $d_Lapp_data_LineageGraphEntry = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_LineageGraphEntry, "app.data.LineageGraphEntry", ({
  jH: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_LineageGraphEntry as $d_Lapp_data_LineageGraphEntry };
//# sourceMappingURL=app.data.-Lineage-Graph-Entry.js.map
